import React from "react";
import CurrentEvent from "../components/ui/current-event";

const CurrentPage = () => {
  return <CurrentEvent />;
};

export default CurrentPage;
